import { useTranslation } from "react-i18next";
import Footer from "../../components/shared/Footer/Footer";
import SEO from "../../components/SEO/SEO";
import Form from "./Form";
import "./style.css";
// import ServicesType from "../../components/ServicesType";
// import ServicesPosition from "../../components/ServicesPosition";
// import ServicesPlan from "../../components/ServicesPlan";
// import AdditionalServices from "../../components/AdditionalServices";
// import Premises from "../../components/Premises";
// import Time from "../../components/Time";
// import ClientInfo from "../../components/ClientInfo";
// import ServicesPrice from "../../components/ServicesPrice";
// import ClientLocation from "../../components/ClientLocation";
// import EndPage from "../../components/EndPage";

const Quote = () => {
  const { t } = useTranslation();
  // const [position, setPosition] = useState(0);
  // const [data, setData] = useState({});

  // const wrapper = document.querySelector(".form-items");
  // const progress = document.querySelector(".progress-level_inner");
  // if (wrapper !== null) {
  //   wrapper.style.cssText = `transform:translateX(-${position}%)`;
  // }
  // if (progress !== null && data.servicesType !== "Moving") {
  //   progress.style.cssText = `width:${position / 9}%`;
  // } else if (progress !== null)
  //   progress.style.cssText = `width:${position / 5}%`;

  // function next(prop) {
  //   if (prop === "next") {
  //     setPosition(position + 100);
  //   } else if (prop === "back") {
  //     setPosition(position - 100);
  //   }
  // }
  return (
    <>
      <SEO 
        title="Get a Quote - Manino Cleaning Services"
        description="Get a free quote for professional cleaning and moving services. Quick online form, competitive prices, quality service guaranteed."
        keywords="cleaning quote, moving quote, free estimate, cleaning services price, Manino quote"
      />
      <section className="tp-services-area">
        <div className="tp-custom-container">
          <div className="tp-services-bg grey-bg pt-110 pb-90 z-index">
            <div className="container">
              <div className="justify-content-center">
                <div>
                  <div
                    className="tp-section-title-wrapper text-center mb-40 wow fadeInUp"
                    data-wow-delay=".1s"
                  >
                    <h5 className="tp-section-subtitle section__sm__title common-yellow-shape">
                      {t("Quote.GetYour")}
                    </h5>

                    {/* <div className="progress-level">
                      <span className="progress-level_inner"></span>
                    </div> */}
                  </div>
                </div>
              </div>

              <Form />

              {/* <div className="form-container">
                <div className="form-items_wrap">
                  <div className="form-items">
                    <ServicesType data={{ next, data, setData }} />
                    <ServicesPosition data={{ next, data, setData }} />
                    {data.servicesType !== "Moving" && (
                      <ServicesPlan data={{ next, data, setData }} />
                    )}
                    {data.servicesType !== "Moving" && (
                      <AdditionalServices data={{ next, data, setData }} />
                    )}
                    {data.servicesType !== "Moving" && (
                      <Premises data={{ next, data, setData }} />
                    )}
                    <Time data={{ next, data, setData }} />
                    <ClientInfo data={{ next, data, setData }} />
                    {data.servicesType !== "Moving" && (
                      <ServicesPrice data={{ next, data, setData }} />
                    )}
                    <ClientLocation data={{ next, data, setData }} />
                    <EndPage data={data} />
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Quote;
